import React from 'react';
import PropTypes from 'prop-types';
import {
  ExtendedBox,
  Heading,
  Body,
  Flex,
} from '../../coreui';

import NonAccred from './PrivatePlacementMessages/NonAccred';
import AccredGTKYNotSubmitted from './PrivatePlacementMessages/AccredGTKYNotSubmitted';
import AccredGTKYSubmitted from './PrivatePlacementMessages/AccredGTKYSubmitted';
import AccredGTKYDenied from './PrivatePlacementMessages/AccredGTKYDenied';

const PrivatePlacementMessage = ({
  accreditationRoleStatus,
  gtkyStatus,
  isSelfAccredCooledOff,
}) => {
  // Not loaded or no message to show.
  if (accreditationRoleStatus === '' || gtkyStatus === '' ||
      // Accredited and approved.
      (accreditationRoleStatus === 'Accredited' && gtkyStatus === 'approved') ||
      // Self-accred and cooled off.
      (accreditationRoleStatus === 'Accredited' && gtkyStatus !== 'denied' && isSelfAccredCooledOff)) {
    return null;
  }

  return (
    <Flex
      flexDirection="column"
      align="center"
      bg="gray.0"
      w={[1]}
      pt={[0, 40]}
    >
      <ExtendedBox
        maxWidth={1600}
        px={[50, 20]}
      >
        <ExtendedBox
          pt={[50, 120]}
          w={1}
          borderTop={1}
          borderColor="gray.7"
        >
          <Heading
            type="H2"
            m={0}
            textTransform="uppercase"
            display="block"
            w={1}
            align="center"
            color="gray.8"
          >
            Private Placements
          </Heading>

          <ExtendedBox
            pt={20}
            w={1}
          >
            <Heading
              type="H6"
              m={0}
              textTransform="uppercase"
              display="block"
              w={1}
              align="center"
              color="gray.8"
            >
              Private Placements offer the opportunity to invest in individual transactions.
            </Heading>
          </ExtendedBox>
        </ExtendedBox>
        <ExtendedBox
          w={1}
          pt={[20, 40]}
          pb={[60, 120]}
        >
          <Body
            type="B1"
            align="center"
            display="block"
            m={0}
            w={1}
            color="gray.8"
          >
            {
              accreditationRoleStatus !== 'Accredited' && gtkyStatus !== 'denied' &&
              <NonAccred />
            }
            {
              accreditationRoleStatus === 'Accredited' && gtkyStatus === 'not_submitted' &&
              <AccredGTKYNotSubmitted />
            }
            {
              accreditationRoleStatus === 'Accredited' && gtkyStatus === 'submitted' &&
              <AccredGTKYSubmitted />
            }
            {
              gtkyStatus === 'denied' &&
              <AccredGTKYDenied />
            }
          </Body>
        </ExtendedBox>
      </ExtendedBox>
    </Flex>
  );
};

PrivatePlacementMessage.propTypes = {
  accreditationRoleStatus: PropTypes.string,
  gtkyStatus: PropTypes.string,
  isSelfAccredCooledOff: PropTypes.bool,
};

export default PrivatePlacementMessage;
